<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isSiteIntegralDetailsDetailLoading">
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="type" slot-scope="data">
            <!-- <span>{{ data.row.type === 10 ? data.row.remark : $wtConst.integralType[data.row.type] }}</span> -->
            <span>{{ $wtConst.integralType[data.row.type] }}</span>
          </template>
          <template slot="integral" slot-scope="data">
            <span style="color: #F56C6C;" v-if="[8, 12, 16, 17, 21, 22].indexOf(data.row.type) > -1">{{ '-' + data.row.integral }}</span>
            <span style="color: #67C23A;" v-else>{{ '+' + data.row.integral }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'siteIntegral-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULE_SITEINTEGRAL',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITEINTEGRAL',
        formComponent: {
          list: { type: 'default', value: '/modules/integralRules/pointsRecordDetail' }
        },
        formInputsData: [
          { name: 'ID', key: 'id', value: '', type: 'customAll' },
          { name: '搜索用户', key: 'userName', value: '', type: 'text' },
          { name: '手机号', key: 'phone', value: '', type: 'text' },
          { name: '时间', key: 'dataTimeRange', value: [], type: 'datetime' }
        ],
        formButtonsData: [
          // { name: '导出Excel',
          //   key: 'EXPORT',
          //   action: 'EXCEL',
          //   hidden: false,
          //   url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralDetailsListImport',
          //   fileName: '站点积分' }
        ],
        formTableData: [
          { name: '用户昵称', key: 'userWechatName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '积分详情', key: 'pointsTypeName', type: 'text' },
          { name: '积分', key: 'points', type: 'text' },
          { name: '时间', key: 'operateTime', type: 'text', sortable: 'custom' },
          { name: '操作人员', key: 'operateUser', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: false, buttonHidden: true }
      }
    }
  },
  created() {
    console.log('this.detailFormData', this.detailFormData)
    this.form.formInputsData[0].value = this.detailFormData.id
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction() {

    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isSiteIntegralDetailsDetailLoading: state => state.siteIntegralDetails.isSiteIntegralDetailsDetailLoading,
      detailFormData: state => state.siteIntegralDetails.siteIntegralDetailsDetailData
    })
  }
}
</script>

<style scoped>

</style>
